export const LOGIN_SUCCESSFUL = 'EVENT/LOGIN_SUCCESSFUL'
export const LOGOUT_SUCCESSFUL = 'EVENT/LOGOUT_SUCCESSFUL'
